'use client';

import { useEffect } from 'react';

export default function CanonicalFallback() {
  useEffect(() => {
    try {
      const existing = document.querySelector("link[rel='canonical']");
      if (existing) return;

      const canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      // Use the full current location (protocol + host + pathname + search)
      canonical.setAttribute('href', window.location.href.split('#')[0]);
      document.head.appendChild(canonical);
    } catch (e) {
      // ignore errors in older browsers
      // eslint-disable-next-line no-console
      console.warn('CanonicalFallback error', e);
    }
  }, []);

  return null;
}
